import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-blog-list',
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './blog-list.component.html',
  styleUrl: './blog-list.component.scss',
})
export class BlogListComponent {
  posts = [
    {
      title: '🚀 Willkommen in meinem Entwickler-Blog',
      slug: 'willkommen',
      description: 'Warum dieser Blog mehr ist als nur Content – eine Mission für echte Coder.'
    },
    {
      title: '🧠 Top 5 Angular-Tipps, die dir niemand sagt',
      slug: 'angular-tipps',
      description: 'Kurz, knackig und direkt aus der Praxis: Diese Angular-Hacks willst du nicht verpassen.'
    },
    {
      title: '📦 Saubere Architektur für dein nächstes Angular-Projekt',
      slug: 'clean-architecture',
      description: 'Modular, wartbar, skalierbar – wie du dein Angular-Projekt wie ein Profi aufziehst.'
    },
    {
      title: '🧠 CQRS & Event Sourcing in Angular – Macht oder Mythos?',
      slug: 'cqrs-event-sourcing-angular',
      description: 'Wie du mit CQRS & Event Sourcing Architektur auf Enterprise-Niveau bringst – und wann du es lieber lässt.'
    },
    {
      title: '📦 Domain-Driven Design in Angular – Die Kunst der Klarheit',
      slug: 'domain-driven-design-angular',
      description: 'Wie du mit DDD Ordnung, Fachlichkeit und Struktur in dein Angular-Universum bringst.'
    },
    {
      title: '🧪 Advanced Testing in Angular – Was Profis wirklich testen',
      slug: 'advanced-testing-angular',
      description: 'Mocks, Signals, Verhaltenstests: Das Level-Up für dein Test-Game.'
    },
    {
      title: '⚡ Angular Signals im Enterprise-Einsatz – Patterns, die du brauchst',
      slug: 'angular-signals-enterprise',
      description: 'Wie du Signals richtig nutzt – von State bis Architecture – im großen Stil.'
    },
    {
      title: '🚀 SignalStore Advanced – Feature Stores auf dem nächsten Level',
      slug: 'signalstore-advanced-angular',
      description: 'Feature-State ohne Overhead: So baust du modulare Stores mit SignalStore.'
    },
    {
      title: '📐 Component Architecture in Angular – Patterns für skalierbare Komponenten',
      slug: 'component-architecture-angular',
      description: 'Smart & Dumb Components, Feature Shells & UI-Blocks – sauber strukturiert.'
    },
    {
      title: '🌍 Internationalisierung (i18n) in Angular – Übersetzungsstrategie, die skaliert',
      slug: 'internationalisierung-angular',
      description: 'Wie du deine Angular-App mehrsprachig, wartbar und global-ready machst.'
    },
    {
      title: '🧱 Angular Forms: Reactive vs. Signals – Was du wann brauchst',
      slug: 'angular-forms-reactive-vs-signals',
      description: 'Formulare strategisch angehen – von klassischen Reactive Forms bis zu modernen Signals.'
    },
    {
      title: '📊 Angular + Highcharts – Dynamische Visualisierungen für Profis',
      slug: 'angular-highcharts-visualisierungen',
      description: 'So bringst du deine Daten visuell zum Leuchten – performante Charts in Angular.'
    },
    {
      title: '📎 Angular + PDF-Export – Automatisierte Reports mit Base64 + Charts',
      slug: 'angular-pdf-export-reports',
      description: 'PDFs mit Branding, Charts und Automation direkt aus deiner Angular-App.'
    },
    {
      title: '🎯 Angular Performance – ChangeDetection, Signals & Zonenfrei',
      slug: 'angular-performance-optimization',
      description: 'Mach deine App messbar schneller – mit OnPush, Signals und zonenlosem Setup.'
    },
    {
      title: '📚 Angular Architektur-Playbook – So startest du jedes Projekt richtig',
      slug: 'angular-architektur-playbook',
      description: 'Von Anfang an richtig: Struktur, Patterns & Tools für wartbare Angular-Projekte.'
    },
    {
      title: '🧠 Angular + AI – Wie du GPT & Co. smart in deine App bringst',
      slug: 'angular-ai-gpt-integration',
      description: 'GPT & Co. in Angular? So integrierst du KI clever in dein Frontend.'
    },
    {
      title: '🔐 Angular Security – Auth, Roles & sichere APIs richtig gemacht',
      slug: 'angular-security-auth-roles',
      description: 'Token, Guards, Interceptors: So schützt du deine Angular-App richtig.'
    },
    {
      title: '🚀 Nx Monorepo Deep Dive – Das volle Power-Setup für Teams',
      slug: 'nx-monorepo-deep-dive',
      description: 'Mehr Ordnung, mehr Speed, mehr Teamwork – mit Nx im Angular-Projekt.'
    },
    {
      title: '📎 Angular + CMS – Flexible Inhalte in strukturierter Architektur',
      slug: 'angular-headless-cms-integration',
      description: 'Mit Headless CMS (Storyblok, Sanity, Strapi) Content flexibel verwalten und rendern.'
    },
    {
      title: '🔍 Angular Content-Suche – Smart Search mit AI + Signals + Fuzzy Logic',
      slug: 'angular-smart-search',
      description: 'Semantische Suche für Angular-Apps – clever, reaktiv, performant.'
    },
    {
      title: '🧱 Angular Admin Dashboards – UX, Patterns & Komponenten für Profis',
      slug: 'angular-admin-dashboards',
      description: 'Modulare, sichere Dashboards mit Angular, Signals & Smart Layouts.'
    },
    {
      title: '🧩 Angular Multi-Step Forms – Stepper, Dynamic Flow & State Handling',
      slug: 'angular-multistep-forms',
      description: 'Wizard-Formulare richtig umgesetzt – reaktiv, modular, UX-freundlich.'
    },
    {
      title: '⚡ Signals + RxJS – Best of both worlds für reactive Power',
      slug: 'signals-rxjs-combo',
      description: 'So kombinierst du UI-State mit asynchronem Stream-Handling – das Beste aus zwei Welten.'
    },
    {
      title: '📚 Angular Knowledge Graph – Wie du dein Team skalierst, ohne die Kontrolle zu verlieren',
      slug: 'angular-knowledge-graph',
      description: 'Doku, Ownership & Architekturbeziehungen visuell, skalierbar und teamfähig abbilden.'
    },
    {
      title: '🧠 Angular Architecture FAQ – 20 Fragen, die dir in jedem Projekt gestellt werden',
      slug: 'angular-architecture-faq',
      description: 'Klartext zu Modulen, Signals, State, Security & Skalierung – schnell und verständlich.'
    },
    {
      title: '📦 Angular Feature Shells – Trennung, Struktur & Lazy Load auf Enterprise-Niveau',
      slug: 'angular-feature-shells',
      description: 'So strukturierst du große Features mit Shell-Komponenten, Lazy Loading und Clean Boundaries.'
    },
    {
      title: '💡 Angular Signals Patterns – Computed, Effect & State für Profis',
      slug: 'angular-signals-patterns',
      description: 'Signals strategisch einsetzen – für Reactive Logic, Clean Architecture & Performance.'
    },
    {
      title: '📚 Angular Projektstart-Playbook – Setup, Struktur, Best Practices',
      slug: 'angular-projektstart-playbook',
      description: 'Von Nx bis CI/CD: So legst du jedes Projekt sauber, testbar und skalierbar an.'
    },
    {
      title: '🧐 Clean Code in Angular – Praktisch, konkret, teamfähig',
      slug: 'angular-clean-code',
      description: 'Lesbar, strukturiert, wartbar – Clean Code in der Angular-Welt wirklich umgesetzt.'
    },
    {
      title: '⚙️ Angular Build-Optimierung – Assets, Fonts & Bundle Magic',
      slug: 'angular-build-optimization',
      description: 'Feinschliff für Profis – von Tree Shaking bis CI: Optimiere dein Bundle wie ein Boss.'
    },
    {
      title: '📊 Angular Analytics & Tracking – Insights statt Blindflug',
      slug: 'angular-analytics-tracking',
      description: 'So bringst du Matomo, GA4, Consent & Custom Tracking DSGVO-konform in Angular.'
    },
    {
      title: '📈 Angular Business Dashboards – Visualisierung, KPIs, UX & Dynamik',
      slug: 'angular-business-dashboards',
      description: 'Wie du KPIs, Charts & Visualisierung für echte Business-Apps in Angular realisierst.'
    },
    {
      title: '📎 Angular CI/CD – GitHub Actions, Nx, Linting, Previews, Deploys',
      slug: 'angular-cicd-workflow',
      description: 'Wie du dein Projekt automatisierst und Qualität in jeden Commit bringst.'
    },
    {
      title: '🛒 Angular E-Commerce Grundlagen – Cart, Auth, Checkout & Headless Integration',
      slug: 'angular-ecommerce-grundlagen',
      description: 'So baust du eine modulare Angular-Shop-Plattform mit Signals, Auth & CMS.'
    },
    {
      title: '🧠 Angular Hiring Guide – Wie du echte Talente erkennst (und Blender entlarvst)',
      slug: 'angular-hiring-guide',
      description: 'Welche Fragen du stellen musst – und wie du als Bewerber überzeugst.'
    },
    {
      title: '📚 Angular Libraries – Struktur, Tools & Publishing Best Practices',
      slug: 'angular-libraries-structure',
      description: 'Wie du wiederverwendbare Libraries in Angular + Nx richtig aufbaust & publizierst.'
    },
    {
      title: '🌐 Angular Microfrontends – Skalierbar entwickeln mit Module Federation',
      slug: 'angular-microfrontends',
      description: 'Wie du Angular Apps aufteilst, zusammenführst und unabhängig deployst.'
    },
    {
      title: '🧠 Angular State Management 2025 – Signals, Stores & Architekturen im Vergleich',
      slug: 'angular-state-management-2025',
      description: 'SignalStore, RxJS, Akita, Zustand, NgRx – Welcher Ansatz passt zu deinem Team?'
    },
    {
      title: '🧩 Angular Plugin-Architektur – Wie du deine App erweiterbar machst',
      slug: 'angular-plugin-architecture',
      description: 'Feature-Plugins, Dynamic Routing und modulare Erweiterbarkeit – die Profi-Strategie für skalierbare Angular-Apps.'
    },
    {
      title: '🎨 Angular Content Projection – Flexible UIs mit `ng-content`, `@ContentChild` & Co.',
      slug: 'angular-content-projection',
      description: 'Wie du mit Content Projection deine Komponenten wirklich wiederverwendbar machst.'
    },
    {
      title: '📊 Angular Charting – Highcharts vs. ApexCharts vs. ngx-charts',
      slug: 'angular-charting-libraries',
      description: 'Vergleich der Top-Charting-Libraries für Angular – Stärken, Schwächen, Best Practices.'
    },
    {
      title: '📚 Angular Knowledge Transfer – So skalierst du Wissen im Team',
      slug: 'angular-knowledge-transfer',
      description: 'Onboarding, Doku, Architektur-Diagramme – so wird Wissen nachhaltig und teamfähig.'
    },
    {
      title: '🚀 Angular Deployment – Docker, CI/CD & Preview Environments',
      slug: 'angular-deployment-cicd',
      description: 'Build, Ship & Preview wie ein Boss – alles, was du fürs moderne Angular-Deployment brauchst.'
    },
    {
      title: '🔐 Angular Auth Strategies – Best Practices für moderne Authentifizierung',
      slug: 'angular-auth-strategies',
      description: 'Token, Interceptor, Guards & OIDC – sichere Auth für Angular-Apps.'
    },
    {
      title: '📦 Angular Modulstruktur – Wie du große Apps übersichtlich hältst',
      slug: 'angular-module-structure',
      description: 'Feature Shells, Shared UI, Core & Co. – so strukturierst du wartbare Angular-Projekte.'
    },
    {
      title: '📈 Angular Observability – Logs, Metrics & Fehler richtig erfassen',
      slug: 'angular-observability',
      description: 'Tracken, Loggen, Überwachen: So siehst du, was wirklich in deiner Angular-App passiert.'
    },
    {
      title: '🔗 Angular API-Integration – REST, GraphQL & Beyond',
      slug: 'angular-api-integration',
      description: 'So dockst du deine Angular-App professionell an jede Schnittstelle.'
    },
    {
      title: '🔁 Angular Change Detection – Verstehen & optimieren',
      slug: 'angular-change-detection',
      description: 'Wie Change Detection funktioniert – und wie du sie performant einsetzt.'
    },
    {
      title: '🧪 Angular Component Testing – Best Practices für Unit & Isolation',
      slug: 'angular-component-testing',
      description: 'Wie du Komponenten sinnvoll testest – pragmatisch und skalierbar.'
    },
    {
      title: '🧵 Angular Control Flow – @if, @for & neue Syntax erklärt',
      slug: 'angular-control-flow',
      description: 'Modernes Angular mit neuer Template-Syntax – was, wie, wann nutzen?'
    },
    {
      title: '📦 Angular Dependency Injection – Deep Dive & Praxisbeispiele',
      slug: 'angular-dependency-injection',
      description: 'Alles rund um DI, Provider, InjectionToken & Scoped Services.'
    },
    {
      title: '🔎 Angular Directives – Deep Dive in Struktur & Verhalten',
      slug: 'angular-directives-deep-dive',
      description: 'Wie du eigene Directives baust, verstehst und elegant einsetzt.'
    },
    {
      title: '📍 Angular Direktiven – Praxis, Patterns & Power-Usage',
      slug: 'angular-direktiven',
      description: 'Alles über Structural, Attribute und Custom Directives – mit echten Praxisbeispielen.'
    },
    {
      title: '🎯 Angular Feature Flags – Dynamic Features richtig steuern',
      slug: 'angular-feature-flags',
      description: 'So schaltest du Features in Echtzeit – von A/B-Test bis Rollout.'
    },
    {
      title: '📁 Angular Folder & File Structure – Clean & Skalierbar',
      slug: 'angular-folder-file-structure',
      description: 'Projektstruktur mit Weitblick – was sich bewährt hat.'
    },
    {
      title: '🧱 Angular Forms Advanced – Dynamik, Custom Controls & Validierung',
      slug: 'angular-forms-advanced',
      description: 'So holst du alles aus Reactive Forms & Signals raus.'
    },
    {
      title: '🔄 Angular Inputs & Outputs – Komponentenbindung richtig gemacht',
      slug: 'angular-inputs-outputs',
      description: 'Input, Output, EventEmitter: Sauber kommunizieren zwischen Komponenten.'
    },
    {
      title: '🗺️ Angular Layouts – Grid, Flex & Responsive Design',
      slug: 'angular-layouts',
      description: 'Wie du performante, flexible Layouts für jedes Gerät umsetzt.'
    },
    {
      title: '📚 Angular Library Best Practices – Code für die Wiederverwendung',
      slug: 'angular-library-best-practices',
      description: 'So entwickelst du wartbare, wiederverwendbare Angular-Bibliotheken.'
    },
    {
      title: '⏱️ Angular Lifecycle Hooks – Der komplette Überblick',
      slug: 'angular-lifecycle-hooks',
      description: 'ngOnInit bis ngOnDestroy – wann, wie und warum du sie einsetzt.'
    },
    {
      title: '📆 Angular Lifecycle – Das große Verständnisdiagramm',
      slug: 'angular-lifecycle',
      description: 'Der Lebenszyklus von Komponenten & Directives visuell erklärt.'
    },
    {
      title: '🌐 Angular Module Federation – Microfrontends clever gedacht',
      slug: 'angular-module-federation',
      description: 'So nutzt du Webpack 5 + Angular für dynamische Module & Sharing.'
    },
    {
      title: '⛓️ Angular Pipes – Transformiere Daten sauber & performant',
      slug: 'angular-pipes',
      description: 'Built-in Pipes, Custom Pipes, Pure vs. Impure – alles im Griff.'
    },
    {
      title: '📊 Angular Project Maturity – Woran du erkennst, wie reif dein Projekt ist',
      slug: 'angular-project-maturity',
      description: 'Von Chaos zu Clean Code – Maturity Stufen für Angular-Projekte.'
    },
    {
      title: '🧭 Angular Routing Advanced – Lazy, Guards & Feature-Driven Navigation',
      slug: 'angular-routing-advanced',
      description: 'Routing ist mehr als nur `path`: Struktur, Strategie & Performance.'
    },
    {
      title: '🧩 Angular Services & State – Backbone deiner Anwendung',
      slug: 'angular-services-backbone',
      description: 'So kapselst du Businesslogik und baust wartbare Services auf.'
    },
    {
      title: '🧠 Angular Signals: computed + effect – Deep Dive in reaktive Power',
      slug: 'angular-signals-computed-effect',
      description: 'Reaktive Logik richtig gedacht: Computed & Side Effects im Griff.'
    },
    {
      title: '🧵 Angular Signals Deep Dive – State, Patterns & Anti-Patterns',
      slug: 'angular-signals-deep-dive',
      description: 'Was du über Angular Signals wirklich wissen musst – aus der Praxis.'
    },
    {
      title: '🧪 Angular Signals + RxJS – Das Beste aus zwei Welten',
      slug: 'angular-signals-rxjs-kombi',
      description: 'So kombinierst du reaktives UI-State-Management mit Streams.'
    },
    {
      title: '📐 Angular Style Guide 2025 – Struktur & Qualität fürs neue Zeitalter',
      slug: 'angular-style-guide-2025',
      description: 'Ein moderner Style Guide für Angular 18+ – mit Signals & Standalone Components.'
    },
    {
      title: '🎨 Angular Theming – Dark Mode, Design Tokens & SCSS-Architektur',
      slug: 'angular-theming',
      description: 'Wie du modernes Design systematisch, skalierbar und dynamisch einsetzt.'
    },
    {
      title: '🧪 Angular Unit Testing – Best Practices für nachhaltige Qualität',
      slug: 'angular-unit-testing-best-practices',
      description: 'Tests schreiben, die helfen – nicht nerven. Tipps für langlebige Testsuiten.'
    },
    {
      title: '🌐 Angular Zone-Free – Performance ohne NgZone?',
      slug: 'angular-zone-free',
      description: 'Wie du Angular ohne Zone.js betreibst – und wann es sich wirklich lohnt.'
    },
    {
      title: '🚀 Angular Zone-Free Development – Echtzeit, Performance & Kontrolle',
      slug: 'angular-zone-free-development',
      description: 'Zonenfrei, reaktiv, präzise: Die Zukunft von Angular-Apps ohne Overhead.'
    }
  ];
}
